<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="姓名" name="realName">
                <a-input v-model:value="searchForm.realName" placeholder="请输入姓名" />
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined />
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->

            <template #intellectualPropertyType="{ text }">
                <dict-render :dict-obj="dictObjs['intellectualsubsidy_type']" :text="text"></dict-render>
            </template>
            <template #authorizationDate="{ text }">
                <span>{{ text && text.split(' ')[0] }}</span>
            </template>
            <template #formAcquisition="{ text }">
                <dict-render :dict-obj="dictObjs['intellectualsubsidy_get']" :text="text"></dict-render>
            </template>
            <template #action="{ record }">
                <div class="table-row-operations">
                    <a @click="onEdit(record)">编辑</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import { dictMixin, tableListMixin } from "@/mixins";
import { sys_enterpriseIntellectual } from "@/api/policyService";
import DictRender from "@/components/other/DictRender";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    { title: "知识产权类别", dataIndex: "intellectualPropertyType", key: "intellectualPropertyType", slots: { customRender: "intellectualPropertyType" } },
    { title: "知识产权名称", dataIndex: "intellectualPropertyName", key: "intellectualPropertyName" },
    { title: "专利号", dataIndex: "patentNumber", key: "patentNumber" },
    { title: "授权日期", dataIndex: "authorizationDate", key: "authorizationDate", slots: { customRender: "authorizationDate" } },
    { title: "取得形式", dataIndex: "formAcquisition", key: "formAcquisition", slots: { customRender: "formAcquisition" } },
    { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
    name: "index",
    mixins: [tableListMixin, dictMixin],
    components: {
        AddOrEditModal,
        DictRender
    },
    data() {
        return {
            dictNames: 'intellectualsubsidy_type,intellectualsubsidy_get',
            columns,
            queryParam: {},
            listUrl: sys_enterpriseIntellectual.pageList,
            listKeyField: "id",
            deleteUrl: sys_enterpriseIntellectual.remove
        }
    },
    methods: {
        onAdd() {
            this.onShowModal('modal');
        },
        onEdit(record) {
            this.getAction({
                url: sys_enterpriseIntellectual.detail,
                params: { id: record.id }
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },

    }
}
</script>

<style scoped></style>
